import { Nullable } from 'cng-common/models/utils'
import { getTokens } from 'core/classes/helpers/StorageHelper'
import { proxy } from 'core/classes/helpers/UrlHelper'
import { HttpHeaders, Rest } from 'core/classes/http'
import Logger from 'core/utils/Logger'

import { ReadWriteAccess } from '../../../configs/access'

export type JBPPartnerAccess = {
  RWAccess: ReadWriteAccess
  ProfileLink: string
  GlobalPartnerAccess: number
  UAMAccessType: 'Geo' | 'Account'
  STRole: string
  STRequestStatus: Nullable<string>
  KeyInitiativesFormat: number
}

type Response = {
  Rows: JBPPartnerAccess[]
}

export const jbpPartnerAccessInitialState: JBPPartnerAccess = {
  RWAccess: ReadWriteAccess.Readonly,
  ProfileLink: 'https://accessmanager.austin.hp.com/uam/RequestSelectUser.aspx',
  GlobalPartnerAccess: ReadWriteAccess.Readonly,
  UAMAccessType: 'Account',
  STRole: 'Partner Business Manager',
  STRequestStatus: null,
  KeyInitiativesFormat: 1,
}

export const getPartnerAccess = async (partnerId: string): Promise<JBPPartnerAccess> => {
  try {
    const url = proxy('/webservice/621/sp/v3/spJBPPartnerAccess/call')
    const [accessToken] = getTokens()
    const headers = new HttpHeaders()
    if (accessToken) {
      headers.add('Authorization', `Bearer ${accessToken}`)
    }
    const payload = {
      'p.PartnerId': partnerId,
    }

    const response = (await Rest.post({ url, payload, headers })) as Response
    const [access] = response.Rows
    return access
  } catch (e) {
    Logger.error('spJBPPartnerAccess:', e)
    return jbpPartnerAccessInitialState
  }
}
